// react
import React from 'react'

// external libs
import _ from 'lodash'

// types
import type { GetProjectResultType } from '../../../../services/web/types/responseWebServiceTypes'
import type { useSiteVisitDetailType } from './siteVisitDetailType'

const useSiteVisitDetail = (props: useSiteVisitDetailType) => {
    const { dataSource } = props
    const [initialData, setInitialData] = React.useState<GetProjectResultType>()

    React.useEffect(() => {
        if (dataSource) {
            setInitialData(dataSource)
        }
    }, [dataSource?.projectID ?? null, dataSource?.submittedID ?? null])

    return { initialData }
}

export default useSiteVisitDetail
